export const GET_CREDENTIAL_LIST = 'GET_CREDENTIAL_LIST';
export const SET_BULK_ADD_DETAILS = 'SET_BULK_ADD_DETAILS';
export const CLEAR_CREDENTIAL_LIST = 'CLEAR_CREDENTIAL_LIST';
